import React from "react";
import './coursesoffstyle.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import bazeleconta from '../../imagesHome/bazeleconta.png';
import SocialLoginRegistrer from './SocialLoginRegistrer';
import Registrercourse from './Registrercourse';

const BazeleConta = () => {
  return (
    <div className="general-frame-bc-cf">
    <div className="general-frame-bazeleconta">
      {/* 🔹 Breadcrumb */}
     

      <div className="cadru-bazeleconta">
        {/* 🔹 Stânga - Titlu și descriere */}

        <div className="breadcrumb-bc">
          <span>Cursuri</span>
          <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
          <span className="current">Bazele Contabilitatii</span>
        </div>
        <div className="bc-main-section">

             <div className="bc-main-left">
  <img src={bazeleconta} alt="bazele conta" />
  <h1>Bazele Contabilitatii</h1>
  <p>
    Contabilitatea este limbajul afacerilor – modul prin care o firma isi
    inregistreaza, analizeaza si raporteaza activitatile economice.
  </p>
  <p>
    In acest curs vei descoperi conceptele fundamentale: active, pasive,
    capitaluri proprii, venituri si cheltuieli. Vei intelege cum se
    construieste bilantul, cum functioneaza conturile si cum sa interpretezi
    informatiile financiare de baza.
  </p>
  <p>
    Nu ai nevoie de cunostinte anterioare – totul este explicat simplu, cu
    exemple practice si exercitii interactive.
  </p>
</div>


        {/* 🔹 Dreapta - card/formular */}
        <div className="bc-main-right">
          <div className="bc-card">
            <h2>Inregistreaza-te gratuit pe ContaLearn</h2>
            <p>Acceseaza cursul "Bazele Contabilitatii" si incepe sa inveti!</p>
          

               <div><Registrercourse /></div>
               <div className="sau-bc">sau</div>
               <div><SocialLoginRegistrer /></div>
          </div>
        </div>
        </div>
      </div>

    

    </div>
      
      {/* 🔹 Secțiunea 2: Ce vei învăța */}
      <div className="cadru-bazeleconta-second">
        <div className="what-you-learn-section">
          <h2 className="section-title-bc">Ce vei invata in acest curs</h2>
          <p className="section-subtitle-bc">
            Parcurgi conceptele fundamentale ale contabilitatii, pas cu pas, cu exemple practice si exercitii interactive.
          </p>

          <div className="modules-grid-bc">
            {/* Modul 1 */}
            <div className="module-card-bc">
              <div className="module-icon-bc">📚</div>
              <h3 className="module-title-bc">Introducere in contabilitate</h3>
              <p className="module-desc-bc">
                Descopera ce este contabilitatea, de ce este importanta si cum te ajuta sa intelegi afacerile.
              </p>
            </div>

            {/* Modul 2 */}
            <div className="module-card-bc">
              <div className="module-icon-bc">💰</div>
              <h3 className="module-title-bc">Active, Pasive si Capitaluri</h3>
              <p className="module-desc-bc">
                Intelege cele mai importante elemente financiare: ce detine firma, ce datoreaza si ce apartine actionarilor.
              </p>
            </div>

            {/* Modul 3 */}
            <div className="module-card-bc">
              <div className="module-icon-bc">📊</div>
              <h3 className="module-title-bc">Bilantul contabil</h3>
              <p className="module-desc-bc">
                Invata sa construiesti si sa interpretezi bilantul - fotografia financiara a unei firme.
              </p>
            </div>

            {/* Modul 4 */}
            <div className="module-card-bc">
              <div className="module-icon-bc">🔢</div>
              <h3 className="module-title-bc">Conturile si registrele</h3>
              <p className="module-desc-bc">
                Cum functioneaza conturile contabile, inregistrarea in debit si credit, si planul de conturi.
              </p>
            </div>

            {/* Modul 5 */}
            <div className="module-card-bc">
              <div className="module-icon-bc">📈</div>
              <h3 className="module-title-bc">Venituri si cheltuieli</h3>
              <p className="module-desc-bc">
                Analizeaza cum se genereaza profitul: difera dintre incasari si plati, si impactul asupra rezultatului.
              </p>
            </div>

            {/* Modul 6 */}
            <div className="module-card-bc">
              <div className="module-icon-bc">✅</div>
              <h3 className="module-title-bc">Aplicatii practice</h3>
              <p className="module-desc-bc">
                Exercitii interactive si studii de caz care te ajuta sa aplici ce ai invatat in situatii reale.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 3: Statistici curs */}
      <div className="stats-section-bc">
        <div className="stats-container-bc">
          <h2 className="section-title-bc">Ce include cursul</h2>
          
          <div className="stats-grid-bc">
            <div className="stat-item-bc">
              <div className="stat-icon-bc">📘</div>
              <div className="stat-number-bc">300+</div>
              <div className="stat-label-bc">Lectii interactive</div>
            </div>

            <div className="stat-item-bc">
              <div className="stat-icon-bc">📝</div>
              <div className="stat-number-bc">4000+</div>
              <div className="stat-label-bc">Quiz-uri si teste</div>
            </div>

            <div className="stat-item-bc">
              <div className="stat-icon-bc">🧪</div>
              <div className="stat-number-bc">150+</div>
              <div className="stat-label-bc">Aplicatii practice</div>
            </div>

            <div className="stat-item-bc">
              <div className="stat-icon-bc">🏅</div>
              <div className="stat-number-bc">40+</div>
              <div className="stat-label-bc">Insigne de progres</div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 4: Beneficii */}
      <div className="benefits-section-bc">
        <div className="benefits-container-bc">
          <h2 className="section-title-bc">De ce sa alegi ContaLearn</h2>
          
          <div className="benefits-list-bc">
            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Inveti in ritmul tau</h4>
                <p>Acceseaza lectiile oricand, de oriunde - pe web sau mobile</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Exercitii interactive</h4>
                <p>Nu doar teorie - aplici imediat ce inveti prin jocuri si teste</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Feedback instant</h4>
                <p>Afli imediat daca raspunsul tau este corect si de ce</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Urmareste-ti progresul</h4>
                <p>Vezi cat ai avansat si ce mai ai de invatat</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Certificat de absolvire</h4>
                <p>Primesti un certificat oficial dupa finalizarea cursului</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Zero cunostinte necesare</h4>
                <p>Perfect pentru incepatori - incepem de la baza</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 5: Final CTA */}
      <div className="final-cta-bc">
        <div className="cta-content-bc">
          <h2>Gata sa incepi?</h2>
          <p>Inregistreaza-te gratuit si incepe sa inveti contabilitate astazi!</p>
          <div className="cta-buttons-bc">
            <Registrercourse />
            <div className="sau-cta-bc">sau</div>
            <SocialLoginRegistrer />
          </div>
        </div>
      </div>

    </div>
  );
};

export default BazeleConta;
